import React from 'react';
import './UsersTab.css';
import ChatsTab from '../ChatsTab/ChatsTab';

const UsersTab = ({
    proUsers,
    selectedChat,
    messages,
    newMessage,
    isSending,
    messagesEndRef,
    chatMessagesRef,
    handleInitiateChat,
    handleCloseChat,
    handleSendMessage,
    setNewMessage,
    formatDate
}) => {
    return (
        <div className="admin-chat-container">
            <div className="users-list">
                {proUsers.length === 0 ? (
                    <div className="empty-users">
                        <p>No pro users found</p>
                    </div>
                ) : (
                    proUsers.map(user => (
                        <div 
                            key={user.id} 
                            className="user-item"
                            onClick={() => handleInitiateChat(user)}
                        >
                            <div className="user-item-name">
                                {user.displayName || user.email || 'Anonymous User'}
                            </div>
                            <button className="initiate-chat-btn">
                                Chat
                            </button>
                        </div>
                    ))
                )}
            </div>
            
            <div className="chat-detail">
                {selectedChat ? (
                    <>
                        <div className="chat-header">
                            <h3>{selectedChat.userName || 'Anonymous User'}</h3>
                        </div>
                        
                        <div className="chat-messages admin-view" ref={chatMessagesRef}>
                            {messages.length === 0 ? (
                                <div className="empty-chat">
                                    <p>No messages yet. Start the conversation!</p>
                                </div>
                            ) : (
                                messages.map(message => (
                                    <div 
                                        key={message.id} 
                                        className={`message ${message.senderId === 'admin' ? 'admin' : 'user'}`}
                                    >
                                        <div className="message-content">
                                            <p>{message.text}</p>
                                            <span className="message-time">
                                                {formatDate(message.timestamp)}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            )}
                            <div ref={messagesEndRef} />
                        </div>
                        
                        <form className="chat-input-form" onSubmit={handleSendMessage}>
                            <input
                                type="text"
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                placeholder="Type your message here..."
                                disabled={isSending}
                            />
                            <button type="submit" disabled={!newMessage.trim() || isSending}>
                                {isSending ? 'Sending...' : 'Send'}
                            </button>
                        </form>
                        
                    </>
                ) : (
                    <div className="no-chat-selected">
                        <p>Select a pro user to start a conversation</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UsersTab; 